import { Navigate } from "react-router-dom";
import { isSessionExpired, expireSession } from "../utils/axiosconfig";

export const PrivateRoutes = ({ children, allowedRoles = [] }) => {
  const storedUser = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const hasToken = !!storedUser?.token;
  const userRole = String(storedUser?.role || "").toLowerCase();

  if (!hasToken) {
    return <Navigate to="/" replace />;
  }

  if (isSessionExpired()) {
    expireSession();
    return <Navigate to="/" replace />;
  }

  if (allowedRoles.length > 0) {
    const normalizedRoles = allowedRoles.map((role) => role.toLowerCase());

    if (!normalizedRoles.includes(userRole)) {
      return (
        <Navigate
          to={userRole === "employee" ? "/admin/my-leads" : "/admin/dashboard"}
          replace
        />
      );
    }
  }

  return children;
};